module.exports = __webpack_public_path__ + "files/1a8b11bf5fd348b4c44f3c510c3eb4b9.png";